import {connect} from "react-redux";
import { GSLogoView } from "../view/logo_view";

const LogoContainer=connect()(GSLogoView);
export default LogoContainer;